import { Controller } from "@hotwired/stimulus";
import Inputmask from "inputmask";

export default class extends Controller {
  connect() {
    Inputmask({ mask: "999999" }).mask(this.element);
  }
}
